import axios from "axios"
import { AppServices, HttpHeaders } from "../Services/AppServices";

const UserServices = {
    getUsers: ({ exclude_userid = 0, per_page = 10, page = 1, search = '', sort_by = '', sort_order = '', status }) => {
        return axios.get(AppServices.GET_USERS(), {
        headers: HttpHeaders().headers,
        params: {
            exclude_userid,
            per_page,
            page,
            search,
            sort_by,
            sort_order,
            status
        }
        });
    },
    saveUser: (data) => {
        if (data.userId) {
            return axios.post(AppServices.UPDATE_USER(data.userId), data, HttpHeaders())
        }
        else {
            return axios.post(AppServices.SAVE_USER(), data, HttpHeaders())
        }
    },
    getUser: (userId) => {
        return axios.get(AppServices.GET_USER(userId), HttpHeaders())
    },
    deleteUser: (data) => {
        return axios.post(AppServices.DELETE_USER(data.userId), data, HttpHeaders())
    },
    resendVerifyEmail: (userId) => {
        return axios.post(AppServices.RESEND_VERIFY_EMAIL(), { userid: userId }, HttpHeaders())
    },
    restoreUser: (data) => {
        return axios.post(AppServices.RESTORE_USER(data.userId), data, HttpHeaders())
    },
    // NEW: change status (activate=1 / deactivate=2)    
    changeStatus: (data) => {
        return axios.post(AppServices.CHANGE_USER_STATUS(data.userId, data.status), {}, HttpHeaders());
    }
}

export default UserServices;
